import type {UpmPlantsContextValue, UpmPlant} from '../types'

export const getPlantName = (upmPlants: UpmPlantsContextValue, plantId: string) => {
  const upmPlant = upmPlants[plantId] as UpmPlant | undefined
  return upmPlant ? upmPlant.name : `Plant: ${plantId}`
}
